'use client';

import { c as _c } from "react/compiler-runtime";
import { ProductCardQuickAdd } from './product-card-quick-add';
import { getProductCardQuickAddData, ProductCardFrame, type ProductCardProps } from './product-card-shared';
export function ProductCardClient(props) {
  const $ = _c(15);
  let t0;
  if ($[0] !== props.product) {
    t0 = getProductCardQuickAddData(props.product);
    $[0] = props.product;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    primaryImage,
    defaultVariant,
    hasMultipleVariants,
    hasSizeOption
  } = t0;
  let t1;
  if ($[2] !== defaultVariant || $[3] !== hasMultipleVariants || $[4] !== hasSizeOption || $[5] !== primaryImage || $[6] !== props.enableReviews || $[7] !== props.product || $[8] !== props.rating || $[9] !== props.reviewCount || $[10] !== props.showQuickAdd) {
    t1 = props.showQuickAdd ? <ProductCardQuickAdd product={props.product} primaryImage={primaryImage} defaultVariant={defaultVariant} hasMultipleVariants={hasMultipleVariants} hasSizeOption={hasSizeOption} enableReviews={props.enableReviews} rating={props.rating} reviewCount={props.reviewCount} /> : null;
    $[2] = defaultVariant;
    $[3] = hasMultipleVariants;
    $[4] = hasSizeOption;
    $[5] = primaryImage;
    $[6] = props.enableReviews;
    $[7] = props.product;
    $[8] = props.rating;
    $[9] = props.reviewCount;
    $[10] = props.showQuickAdd;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== props || $[13] !== t1) {
    t2 = <ProductCardFrame {...props} quickAddSlot={t1} />;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}